import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { StubSettingsSetup } from "../../components/StubSettingsSetup";

export const StubSettingsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Stub Settings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Stub Settings", navigateTo: "/settings/stub/list" },
        // { text: "Create Stub Settings", navigateTo: "/settings/stub/setup" }
      ]}
      mainContents={<StubSettingsSetup />}
    />
  );
};
